/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Stored on the meeting type. Graded exams ignore it: slot size decides. A dry run stays the AI examiner because it is self-service, not because of this field.
 */
export type EventKindConductedBy = 'lecturer' | 'examiner_agent' | null;
